import { gql } from 'graphql-tag'

const marketMarketQuestionFragment = gql`
  fragment MarketQuestionFragment on MarketQuestion {
    id
    description
  }
`

export const fetchMarketQuestions = gql`
  query FetchMarketQuestions {
    marketQuestions {
      ...MarketQuestionFragment
    }
  }
  ${marketMarketQuestionFragment}
`

export const createMarketQuestion = gql`
  mutation CreateMarketQuestion($description: String!) {
    createMarketQuestion(description: $description) {
      ...MarketQuestionFragment
    }
  }
  ${marketMarketQuestionFragment}
`

export const updateMarketQuestion = gql`
  mutation UpdateMarketQuestion($id: ID!, $description: String!) {
    updateMarketQuestion(marketQuestionId: $id, description: $description) {
      ...MarketQuestionFragment
    }
  }
  ${marketMarketQuestionFragment}
`

export const deleteMarketQuestion = gql`
  mutation DeleteMarketQuestion($id: ID!) {
    deleteMarketQuestion(marketQuestionId: $id)
  }
`
